module.exports = __webpack_public_path__ + "f41ceab53fedf2a1ac13587623e8c5b7.pdf";